import { defineChain } from 'viem';
import { environment } from '../../environments/environment';

export const EXPLORER_LINK = environment.explorerTxLink;

export function createAppChain(rpc: string = environment.rpcEndpoint) {
  return defineChain({
    id: environment.chainId,
    name: environment.chainName,
    nativeCurrency: {
      name: `${environment.chainName} Ether`,
      symbol: 'ETH',
      decimals: 18,
    },
    rpcUrls: {
      default: {
        http: [rpc],
        webSocket: [],
      },
    },
    blockExplorers: {
      default: {
        name: `${environment.chainName} Explorer`,
        url: EXPLORER_LINK,
      },
    },
    contracts: {
      multicall3: {
        address: environment.multicallAddress,
      },
    },
    testnet: environment.network === 'testnet',
    fees: {
      baseFeeMultiplier: 1,
      defaultPriorityFee: 0n,
    },
  });
}
